import React from 'react';
import { getBlockIcon, getBlockTitle } from '@simpledotink/notion-utils';
import { cs, isUrl } from '../utils';
import { DefaultPageIcon } from '../icons/default-page-icon';
import { useNotionContext } from '../context';
import { LazyImage } from './lazy-image';
var isIconBlock = function (value) {
    return (value.type === 'page' ||
        value.type === 'callout' ||
        value.type === 'collection_view' ||
        value.type === 'collection_view_page');
};
export var PageIcon = function (_a) {
    var _b, _c, _d;
    var block = _a.block, className = _a.className, _e = _a.hideDefaultIcon, hideDefaultIcon = _e === void 0 ? false : _e, defaultIcon = _a.defaultIcon, collection = _a.collection;
    var _f = useNotionContext(), mapImageUrl = _f.mapImageUrl, recordMap = _f.recordMap;
    if (!isIconBlock(block)) {
        return null;
    }
    var icon = (_b = getBlockIcon(block, recordMap)) !== null && _b !== void 0 ? _b : defaultIcon;
    var title = getBlockTitle(block, recordMap);
    if (icon && isUrl(icon)) {
        var url = void 0;
        if (collection && (collection === null || collection === void 0 ? void 0 : collection.icon) == ((_c = block === null || block === void 0 ? void 0 : block.format) === null || _c === void 0 ? void 0 : _c.page_icon)) {
            url = (_d = block === null || block === void 0 ? void 0 : block.format) === null || _d === void 0 ? void 0 : _d.page_icon;
            url = "https://www.notion.so".concat(url.startsWith('/image') ? url : "/image/".concat(encodeURIComponent(url)));
            var notionImageUrlV2 = new URL(url);
            notionImageUrlV2.searchParams.set('table', 'collection');
            notionImageUrlV2.searchParams.set('id', collection.id);
            notionImageUrlV2.searchParams.set('cache', 'v2');
            url = notionImageUrlV2.toString();
        }
        else {
            /*
            sometimes the notion url comes with https://www.notion.so just before the aws link like => https://www.notion.sohttps://awslink
            */
            url = icon;
            if (url.startsWith('https://www.notion.soh'))
                url = url.replace('https://www.notion.so', '');
            url = mapImageUrl(url, block);
        }
        // adding a default width if from notion
        if (url.includes('www.notion.so')) {
            url += '&width=500';
        }
        return (React.createElement(LazyImage, { className: cs(className, 'notion-page-icon'), src: url, alt: title ? title : 'Icon' }));
    }
    else {
        var iconValue = icon === null || icon === void 0 ? void 0 : icon.trim();
        if (!iconValue) {
            if (hideDefaultIcon
            // ||
            // (block.type == 'page' &&
            //   block.parent_table == 'collection' &&
            //   !block.format
            // )
            ) {
                return null;
            }
            return (React.createElement(DefaultPageIcon, { className: cs(className, 'notion-page-icon'), alt: title ? title : 'Page' }));
        }
        return (React.createElement("span", { className: cs(className, 'notion-page-icon'), role: 'img', "aria-label": icon }, iconValue));
    }
};
//# sourceMappingURL=page-icon.js.map